import {
  SET_SERVICE_UI_FLAG,
  CLEAR_SERVICES,
  SET_SERVICES,
  SET_SERVICE_ITEM,
  EDIT_SERVICE,
  DELETE_SERVICE,
} from './types';
import ServicesAPI from '../../../api/services';

export const actions = {
  create: async ({ commit }, serviceInfo) => {
    commit(SET_SERVICE_UI_FLAG, { isCreating: true });
    try {
      const response = await ServicesAPI.create(serviceInfo);
      const service = response.data;
      commit(SET_SERVICE_ITEM, service);
      return service;
    } finally {
      commit(SET_SERVICE_UI_FLAG, { isCreating: false });
    }
  },
  get: async ({ commit }) => {
    commit(SET_SERVICE_UI_FLAG, { isFetching: true });
    try {
      const { data } = await ServicesAPI.get();
      commit(CLEAR_SERVICES);
      commit(SET_SERVICES, data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_SERVICE_UI_FLAG, { isFetching: false });
    }
  },
  show: async ({ commit }, { id }) => {
    commit(SET_SERVICE_UI_FLAG, { isFetchingItem: true });
    try {
      const response = await ServicesAPI.show(id);
      commit(SET_SERVICE_ITEM, response.data);
      commit(SET_SERVICE_UI_FLAG, {
        isFetchingItem: false,
      });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_SERVICE_UI_FLAG, {
        isFetchingItem: false,
      });
    }
  },
  update: async ({ commit }, { id, ...updateObj }) => {
    commit(SET_SERVICE_UI_FLAG, { isUpdating: true });
    try {
      const response = await ServicesAPI.update(id, updateObj);
      commit(EDIT_SERVICE, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_SERVICE_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, serviceId) => {
    commit(SET_SERVICE_UI_FLAG, { isDeleting: true });
    try {
      await ServicesAPI.delete(serviceId);
      commit(DELETE_SERVICE, serviceId);
    } catch (error) {
      const errorMessage = error?.response?.data?.error || error?.message;
      throw new Error(errorMessage || error);
    } finally {
      commit(SET_SERVICE_UI_FLAG, { isDeleting: false });
    }
  },
  createSubService: async ({ commit }, { serviceId, subServiceInfo }) => {
    commit(SET_SERVICE_UI_FLAG, { isCreating: true });
    try {
      const response = await ServicesAPI.createSubService(
        serviceId,
        subServiceInfo
      );
      const service = response.data;
      commit(SET_SERVICE_ITEM, service);
      return service;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_SERVICE_UI_FLAG, { isCreating: false });
    }
  },
  updateSubService: async (
    { commit },
    { serviceId, subServiceId, subServiceInfo }
  ) => {
    commit(SET_SERVICE_UI_FLAG, { isUpdating: true });
    try {
      const response = await ServicesAPI.updateSubService(
        serviceId,
        subServiceId,
        subServiceInfo
      );
      const service = response.data;
      commit(SET_SERVICE_ITEM, service);
      return service;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_SERVICE_UI_FLAG, { isUpdating: false });
    }
  },
  deleteSubService: async ({ commit }, { serviceId, subServiceId }) => {
    commit(SET_SERVICE_UI_FLAG, { isDeleting: true });
    try {
      const response = await ServicesAPI.deleteSubService(
        serviceId,
        subServiceId
      );
      const service = response.data;
      commit(SET_SERVICE_ITEM, service);
      return service;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_SERVICE_UI_FLAG, { isDeleting: false });
    }
  },
};
